<template>
    <FormGroup class="admin-form-group">
        <slot></slot>
    </FormGroup>
</template>
